import Header from "@/components/Header";
import Hero from "@/components/Hero";
import FeaturedEMRs from "@/components/FeaturedEMRs";
import ResourcesSection from "@/components/ResourcesSection";
import EMRDirectory from "@/components/EMRDirectory";
import TrustIndicators from "@/components/TrustIndicators";
import Footer from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead 
        title="Best Behavioral Health EMR Software 2025 | Compare Top EHR Systems"
        description="Compare the best behavioral health EMR systems. Get expert recommendations for your practice size, specialty, and workflow needs."
        canonical="/"
      />
      <Header />
      <Hero />
      <FeaturedEMRs />
      <ResourcesSection />
      <EMRDirectory />
      <TrustIndicators />
      <Footer />
    </div>
  );
};

export default Index;
